
import Group from 'vux/src/components/group/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


export default {
components: {
Group,
XInput,
XHeader,
XButton,
Toast
},
name: "login",
data() {
return {
passwd: "",
account: "",
showAD: true,
adSrc: "/static/img/ad.png",
adTime: 0,
flag: false,
interval: '',
register: ''
};
},
methods: {
close() {
clearInterval(this.interval)
localStorage.setItem('showAD', '')
this.showAD = false;
},
gotoVipPage() {
this.$router.push({
name: "vip"
});
},
adTimeshow() {
this.interval = setInterval(() => {
let countDown = parseInt(this.adTime);
if (countDown === 0) {
clearInterval(this.interval);
localStorage.setItem('showAD', '')
this.showAD = false;
} else {
countDown--;
this.adTime = countDown;
}
}, 1000);
},
login() {
var userInfo = {
passwd: this.passwd,
account: this.account,
is_passwd: true,
tp:'mobile'
};
var app = this;
this.$http.post("/api/v1/accounts", userInfo).then((response) => {
if (app.flag) {
app.$router.push({name: "userhomepage"});
} else {
let head = {
headers: {
token: response.data.token,
opid: response.data.userid
}
};
let opid = response.data.userid;
let openid = localStorage.getItem("openid");
const unionid = localStorage.getItem('unionid')

const nickname = localStorage.getItem('nickname')
const imgurl = localStorage.getItem('imgurl')
let obj = {
account: response.data.userid.toString(),
unionid:unionid,
nickname:nickname,
imgurl:imgurl,
otp:'official'
};
localStorage.setItem("account", app.account);
localStorage.setItem("token", response.data.token);
localStorage.setItem("userid", response.data.userid);
app.$http.get("/api/v1/wechat/" + unionid).then(res => {



if (res.data.indexOf(app.account) != -1) {
app.gotoVipPage();
} else {
app.$http.get('api/v1/accounts/' + opid, head).then(resp => {
let bool = false
for (let i = 0; i < resp.data.length; i++) {
if (resp.data[i].type == 'INDV' || resp.data[i].type == 'EXPT') {
bool = true
break;
}
}
if (bool) {
app.$http.post("/api/v1/wechat/" + openid, obj, head).then(res => {
if (localStorage.getItem('history')) {
this.$router.push({
name: "attention", query: {id: localStorage.getItem('history')}
});
return
}
if (localStorage.getItem('repair')) {
let obj;
obj = localStorage.getItem('repair') === 'solution_logs' ? {
name: localStorage.getItem('repair'),
params: {
role: localStorage.getItem('repairtype')
}
} : {
name: localStorage.getItem('repair')
}
this.$router.push(obj)
localStorage.removeItem('repair')
return
}
if (localStorage.getItem('viwocertificate')) {
this.$router.push({name: 'viwocertificate'})
return;
}
app.gotoVipPage();
app.$vux.toast.show({
text: "登录成功",
type: "success",
time: "1000"
});

}).catch(function (error) {
app.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: "cancel",
time: "1000"
})
});
} else {
app.$vux.toast.show({
text: "该身份暂不允许登录",
type: "cancel",
time: "1000"
})
}
})

}
}).catch(function (error) {
app.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: "cancel",
time: "1000"
})
});

}
}).catch(function (error) {
if (error.response) {
console.log(error.response.data);
if (error.response.data.error_message) {
app.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: "cancel",
time: "1000"
});
}
} else if (error.request) {
console.log(error.request);
} else {
console.log("Error", error.message);
}
});
}
},
created() {
this.adTimeshow();
},
beforeRouteEnter(to, from, next) {
if (from.name === "register" || from.name === "RegisterType") {
next(vm => {
vm.adTime = 0;
vm.showAD = false;
localStorage.setItem('showAD', '')
});
} else {
next(vm => {
vm.adTime = 5;
localStorage.setItem('showAD', 'true')
vm.register = localStorage.getItem('history') ? {
name: 'register',
query: {role: 'users'}
} : {name: 'RegisterType'}
});
}
}
};



// WEBPACK FOOTER //
// ./src/components/login/login.vue